import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import OlMap from "ol/Map";
import OlXYZ from "ol/source/XYZ";
import OlTileLayer from "ol/layer/Tile";
import OlView from "ol/View";
import Draw from "ol/interaction/Draw";
import Point from "ol/geom/Point.js";
import { fromLonLat } from "ol/proj";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer.js";
import { OSM, Vector as VectorSource } from "ol/source.js";
import Feature from "ol/Feature.js";
import { DataService } from "../service/buildings.service";

import Overlay from "ol/Overlay.js";
import { Circle, Fill, Icon, Stroke, Style } from "ol/style.js";
import { Observable, Observer } from "rxjs";
import { getBottomLeft, getTopRight } from "ol/extent.js";
import { toLonLat } from "ol/proj.js";
import { MatTabChangeEvent, MatDialog, PageEvent } from "@angular/material";
import { HomeDetailsDialogComponent } from "../home-details-dialog/home-details-dialog.component";

import { SELECT_VALUE_ACCESSOR } from "@angular/forms/src/directives/select_control_value_accessor";
// import { Overlay } from '@angular/cdk/overlay';

export interface ExampleTab {
  label: string;
  content: string;
}
export class RoomsType {
  Type=12;
  Count=0;
}
@Component({
  selector: "app-rent",
  templateUrl: "./rent.component.html",
  styleUrls: ["./rent.component.scss"]
})
export class RentComponent implements OnInit {
  
  type = ["LineString", "Point", "Polygon", "Circle"];

  menu: number;
  
  latitude: number = 41.325204;
  
  longitude: number = 69.28567;
  
  img: undefined;
  
  map: OlMap;
  
  source: OlXYZ;
  
  layer: OlTileLayer;
  
  view: OlView;
  
  startMarker: Feature;
  
  buildings: object[];
  
  startMarker2: Feature;
  
  vectorLayer: VectorLayer;
  
  popup: Overlay;
  
  room=new RoomsType();
  
  vectorLayer2: VectorLayer;
  
  icon: any;
  
  snap: any;
  
  lat: any;
  
  lon: any;
  
  tabSortvalue: number;
  
  buildingPhotos: any;

  markerSource: any;
  
  markerStyle: any;
  
  keyword: string;

  beds: number;
  
  price: number;
  
  byall:any;
  
  buildtype:any;
  
  currentpage:number;

  asyncTabs: Observable<ExampleTab[]>;

  details: any;

  totalCount:number;

  // MatPaginator Output
  pageEvent: PageEvent;
  
  constructor(private service: DataService, public dialog: MatDialog) {
   
    this.tabSortvalue = 1;
   
    this.currentpage = 1;
  }

  paginator(v:number){
    v++;
    console.log("v:"+v);
    this.currentpage=v;
    this.filterK();
  }
   
  filterK() {

    this.service.currentMessage.subscribe(keyword => (this.keyword = keyword));

    this.service.filterPrice.subscribe(price => (this.price = price));

    this.service.filterbed.subscribe(bed => (this.beds = bed));

    this.service.filterByAll.subscribe(byall => (this.byall = byall));

    this.service.filterbuildingType.subscribe(buildtype => (this.buildtype = buildtype));
    
    this.room.Count=this.beds;
    
    this.room.Type=12;
  
    let data = {
      pageSize: 10,
      currentPage: this.currentpage,
      keyword: this.keyword,
      regionId: null,
      districtId: null,
      zoneId: null,
      clientTypeId: null,
      priceFrom: null,
      priceTo: null,
      size: null,
      buildActionTypes:null,
      buildTypes: null,
      rooms:null,
      sortType: this.tabSortvalue,
      points: null
    };
    if(this.price>0)
    {
      data.priceFrom=this.price;
      data.priceTo=this.price+99999;
    }
    if(this.room.Count>0){
      data.rooms= [{
      "type":  this.room.Type,
      "count": [ this.room.Count,this.room.Count++,this.room.Count++,this.room.Count++,this.room.Count++,this.room.Count++,this.room.Count++,this.room.Count++]
  }]}
    if(this.buildtype.length>0){
      data.buildTypes= this.buildtype
  }
    if(this.byall.length>0){
      data.buildActionTypes= this.byall
      }

      console.log("currentpage:"+data.currentPage);
    this.search(data);
  }

  tabSort(data: number) {
    
    this.tabSortvalue = data+1;
    
    this.filterK();
  }

  showHome(home_id) {
    console.log(home_id);
    this.service.getDetails(home_id).subscribe(
      data => {
        this.details = data;
        this.dialog.open(HomeDetailsDialogComponent, {
          data: this.details,
          panelClass: "home-details-dialog",
          autoFocus: false
        });
      },
      error => console.log("error:" + error)
    );
  }
  ngOnInit() {
    this.service.currentMessage.subscribe(keyword => (this.keyword = keyword));
    console.log("buy keyword:" + this.keyword);

    let data = {
      pageSize: 10,
      currentPage: this.currentpage,
      keyword: this.keyword,
      regionId: null,
      districtId: null,
      zoneId: null,
      clientTypeId: null,
      priceFrom: null,
      priceTo: null,
      size: null,
      buildActionTypes: null,
      buildTypes: null,
      rooms:null,
      sortType: 1,
      points: null
    };
    console.log("currentpage:"+data.currentPage);
   
   

    this.source = new VectorSource({ wrapX: false });

    this.layer = new TileLayer({
      source: new OSM()
    });

    this.startMarker = new Feature({
      geometry: new Point(fromLonLat([6.661594, 50.433237])),

      color: "yellow"
    });

    this.startMarker.setStyle(
      new Style({
        image: new Circle({
          radius: 12,
          stroke: new Stroke({
            color: "#fff"
          }),
          fill: new Fill({
            color: "yellow"
          })
        })
        // text: new Text({
        //   text: size.toString(),
        //   fill: new Fill({
        //     color: '#fff'
        //   })
        // })
        // image: new Icon(/** @type {module:ol/style/Icon~Options} */({
        //   crossOrigin: 'anonymous',
        //   anchor: [0.5, 0.96],
        //   src: 'https://cdn3.iconfinder.com/data/icons/map-markers-1/512/residence-512.png',
        //   scale: 0.09,
        // }))
      })
    );

    this.view = new OlView({
      center: fromLonLat([69.2401, 41.2995]),
      zoom: 12
    });
    this.vectorLayer = new VectorLayer({
      source: this.source
    });

    /**
     * Elements that make up the popup.
     */
    var isContainerVisible = false;
    var container = document.getElementById("popup");
    var content = document.getElementById("popup-content");

    /**
     * Create an overlay to anchor the popup to the map.
     */
    var overlay = new Overlay({
      element: container,
      autoPan: false,
    });

    this.map = new OlMap({
      target: "map",
      overlays: [overlay],
      layers: [this.layer, this.vectorLayer],
      view: this.view
    });
    let self = this;
    this.map.on("moveend", function(e) {
      var map = e.map;

      var extent = map.getView().calculateExtent(map.getSize());

      // this.view.fit(this.vectorLayer.getSource().getExtent(), {duration: 1000})

      var bottomLeft = toLonLat(getBottomLeft(extent));

      var topRight = toLonLat(getTopRight(extent));
      console.log("left", bottomLeft[0]);
      console.log("bottom", bottomLeft[1]);
      console.log("right", topRight[0]);
      console.log("top", topRight[1]);
    });
    var container = document.getElementById("popup");

    let thisc = this;

    // display popup on click/pointermove

    this.map.on("pointermove", function(evt) {
      var feature = thisc.map.forEachFeatureAtPixel(
        evt.pixel,
        function(feature) {
          return feature;
        },
        { hitTolerance: 3 }
      );
      if (feature) {
        content.innerHTML =
          '<div style="width: 122px; height: 58px; display: grid; grid-template-columns: 50% 50%; grid-template-rows: 1fr;grid-gap:5px;">' +
          '<div style="width: 100%; height: 100%; grid-column-start: 1; grid-column-end: 2;">' +
          '<img style="height: 100%; width: 100%;" src="http://honadon.uz/' +
          feature.get("imagepath") +
          '" alt="Home Image"/>' +
          "</div>" +
          '<div style="width: 100%; height: 100%; display: flex; flex-direction: column; grid-column-start: 2; grid-column-end: 3;">' +
          '<span style="font-weight: bold;"> $' +
          feature.get("ownerPrice") +
          "</span>" +
          "<span>" +
          feature.get("size") +
          " " +
          feature.get("sizeName") +
          "</span>" +
          "</div>" +
          "</div>";
        overlay.setPosition(evt.coordinate);
        if (!isContainerVisible) {
          container.parentElement.style.display = "block";
          isContainerVisible = true;
        }
      } else if (isContainerVisible) {
        container.parentElement.style.display = "none";
        isContainerVisible = false;
      }
    });

    this.map.on("click", function(evt) {
      var feature = thisc.map.forEachFeatureAtPixel(evt.pixel, function(
        feature
      ) {
        return feature;
      });
      if (feature) {
        self.showHome(feature.get("id"));
      } else {
      }
    });

    let draw = new Draw({
      source: this.source,
      type: "Polygon",
      freehand: true
    });

    console.log(
      "map getview: " + this.map.getView().getCenter(),
      "EPSG:21781",
      "EPSG:4326"
    );
    this.search(data);
  }

  search(data) {
    // this.startMarker.clearMarkers();
    // var container = document.getElementById("popup");
    this.map.removeLayer(this.layer);
    this.map.addLayer(this.layer);
    // var overlay = new Overlay({
    //   element: container,
    //   autoPan: false,
    // });

    // this.map = new OlMap({
    //   target: "map",
    //   overlays: [overlay],
    //   layers: [this.layer, this.vectorLayer],
    //   view: this.view
    // });
    var clonethis = this;
    this.service.searchBuildings(data).subscribe(next => {
      let res = next["buildings"];
      this.totalCount=next["totalCount"];
      console.log("res:" + res.buildTitle);

      //resUsersData is an Object, not an array. Transform it.
      clonethis.buildings = res; //Object.keys(next["buildings"]).map(key => next["buildings"][key])
      console.log("Buildings111:" + JSON.stringify(clonethis.buildings));
      clonethis.buildings.forEach(function(value: any) {
        console.log(value.id);
      
        
        clonethis.startMarker = new Feature({
          geometry: new Point(
            fromLonLat([
              value.longitude.toString().replace(",", "."),
              +value.latitude.toString().replace(",", ".")
            ])
          )
        });
        clonethis.startMarker.setProperties({
          id: value.id,
          ownerPrice: value.ownerPrice,
          imagepath: value.buildingPhotos[0]
            ? value.buildingPhotos[0].path
            : "Storage/DefaultPhotos/nophoto.png",
          size: value.size,
          sizeName: value.sizeName
        });

        clonethis.startMarker.setStyle(
          new Style({
            image: new Circle({
              radius: 7,
              stroke: new Stroke({
                color: "white",
                width: 3.5
              }),
              fill: new Fill({
                color:
                  value.buildAction === "Sotuvga qo'yish" ||
                  value.buildAction === "Продажа" ||
                  value.buildAction === "Sale"
                    ? "red"
                    : "#0074e4"
              })
            })
          })
        );
        clonethis.vectorLayer = new VectorLayer({
          source: new VectorSource({
            features: [clonethis.startMarker]
          })
        });

        clonethis.map.addLayer(clonethis.vectorLayer);

        // }.bind(clonethis));
      }),
        error => {
          console.log("Error", error);
        };
    });
  }
}
